import type * as React from 'react'
import { Toaster as Sonner } from 'sonner'
import { useMobile } from '../../../hooks/use-mobile'

type ToasterProps = React.ComponentProps<typeof Sonner>

const Toaster = ({ ...props }: ToasterProps) => {
  const isMobile = useMobile()

  return (
    <Sonner
      theme="system"
      className="toaster group"
      position={isMobile ? 'top-center' : 'bottom-right'}
      toastOptions={{
        classNames: {
          toast:
            'group toast group-[.toaster]:bg-bg-elevated group-[.toaster]:text-text-primary group-[.toaster]:border-border-default group-[.toaster]:shadow-md',
          description: 'group-[.toast]:text-text-secondary',
          actionButton: 'group-[.toast]:bg-primary group-[.toast]:text-primary-fg',
          cancelButton: 'group-[.toast]:bg-bg-muted group-[.toast]:text-text-secondary',
          error: '!text-error !border-error/20 !bg-error-subtle',
          success: '!text-success !border-success/20 !bg-success-subtle',
          warning: '!text-warning !border-warning/20 !bg-warning-subtle',
          info: '!text-info !border-info/20 !bg-info-subtle',
        },
      }}
      {...props}
    />
  )
}

export { Toaster }
